import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const SaleServiceFaq = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('insale'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 16, color: '#000000', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('service_support')}</span>
                <span style={{ fontSize: 14, color: '#333333', marginTop: 10, lineHeight: '22px', fontWeight: '500' }}>{t('service_exchange')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('service_exchange_detail')}</span>
                <span style={{ fontSize: 16, color: '#000000', marginTop: 30, lineHeight: '22px', fontWeight: '500' }}>{t('service_rule')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('service_rule_content')}</span>
                <span style={{ fontSize: 14, color: '#333333', marginTop: 10, lineHeight: '22px', fontWeight: '500' }}>{t('service_policy')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('service_policy_content')}</span>
                <span style={{ fontSize: 16, color: '#000000', marginTop: 30, lineHeight: '22px', fontWeight: '500' }}>{t('un_service_policy')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('un_service_policy_content')}</span>
                <span style={{ fontSize: 16, color: '#000000', marginTop: 30, lineHeight: '22px', fontWeight: '500' }}>{t('performance_problem')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('performance_problem_content')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('service_policy_tip')}</span>
            </div>
        </div>
        <div style={{ height: 80 }} />
    </div>
}

export default SaleServiceFaq